import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSoundWave12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSoundWave12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 10.982v-9.97a.5.5 0 1 1 1 0v9.97a.5.5 0 1 1-1 0M3 8.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0m4-5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0M1.5 5.06a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5m8.5.44a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSoundWave12);
